import Phaser from "phaser";
import LoadingScene from "@/dailyGames/Fishing/scenes/LoadingScene";
import QuestionScene from "@/dailyGames/Fishing/scenes/QuestionScene";
import BeforeQuestionScene from "@/dailyGames/Fishing/scenes/BeforeQuestionScene";
import AfterQuestionScene from "@/dailyGames/Fishing/scenes/AfterQuestionScene";
import BossScene from "@/dailyGames/Fishing/scenes/BossScene";
import LandingScene from "@/dailyGames/Fishing/scenes/LandingScene";
import Settings from "@/dailyGames/Settings";
import Recommendation from "@/dailyGames/Fishing/scenes/Recommendation";


function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      BeforeQuestionScene,
      AfterQuestionScene,
      BossScene,
      Settings,
      Recommendation,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
